'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Fragment } from 'react';
import { ErrorBoundary } from '@s7/base';
import { FooterWidgetContainer } from './FooterWidgetContainer.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var FooterWidget = function(props) {
    var fallback = props.renderSkeleton || function() {
        return /*#__PURE__*/ jsx(Fragment, {});
    };
    return /*#__PURE__*/ jsx(ErrorBoundary, {
        renderFallback: fallback,
        children: /*#__PURE__*/ jsx(FooterWidgetContainer, _extends({}, props))
    });
};

export { FooterWidget, FooterWidget as default };
